export const Keys = {
  ALT: "Alt",
  ARROW_DOWN: "ArrowDown",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  ARROW_UP: "ArrowUp",
  CMD: "Meta",
  CTRL: "Control",
  ENTER: "Enter",
  ESC: "Escape",
  SHIFT: "Shift",
  SLASH: "/",
  A: "a",
  B: "b",
  C: "c",
  D: "d",
  E: "e",
  F: "f",
  G: "g",
  H: "h",
  I: "i",
  J: "j",
  K: "k",
  L: "l",
  M: "m",
  N: "n",
  O: "o",
  P: "p",
  Q: "q",
  R: "r",
  S: "s",
  T: "t",
  U: "u",
  V: "v",
  W: "w",
  X: "x",
  Y: "y",
  Z: "z",
} as const
export type Key = (typeof Keys)[keyof typeof Keys]

export type ModifierKey =
  | typeof Keys.ALT
  | typeof Keys.CMD
  | typeof Keys.CTRL
  | typeof Keys.SHIFT

export type Shortcut = Key | [ModifierKey, Key]
